var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_VAS_CONTROL_DATA_REQUEST, fetchVasControlDataFailure, fetchVasControlDataSuccess } from "../../actions";
import APIIN from "../../../utils/APIIN";
const onFetchVasControlData = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.getCompany(`company/admin/vas?tenantId=${action.payload.tenantId}`)
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        }
        catch (error) {
            if (error instanceof Error)
                reject(error);
        }
    }));
});
function* getVasControlDataWorker(action) {
    try {
        const data = yield call(onFetchVasControlData, action);
        yield put(fetchVasControlDataSuccess(data));
    }
    catch (error) {
        yield put(fetchVasControlDataFailure(error));
    }
}
export function* watchGetVasControlData() {
    yield takeLatest(FETCH_VAS_CONTROL_DATA_REQUEST, getVasControlDataWorker);
}
